var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import ReactMarkdown from 'react-markdown';
import gfm from 'remark-gfm';
import { fontWeight, typography, spacing, borderRadius, color, divider } from '../../constants';
var MarkdownStyled = styled(ReactMarkdown)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  /* Heading styles to be rendered as bold paragraph for now. */\n  h1,\n  h2,\n  h3,\n  h4,\n  h5 {\n    ", "\n    margin: 0;\n    margin-bottom: ", ";\n    font-weight: ", ";\n  }\n  p {\n    ", "\n    margin: 0;\n    margin-bottom: ", ";\n  }\n\n  strong {\n    font-weight: ", ";\n  }\n\n  em {\n    font-style: italic;\n  }\n\n  a {\n    color: ", ";\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  ul {\n    list-style-type: disc;\n  }\n\n  ol {\n    list-style-type: decimal;\n  }\n\n  ul,\n  ol {\n    padding: ", ";\n    padding-left: ", ";\n    margin: 0 0 ", " 0;\n    border: 1px solid ", ";\n    border-radius: ", ";\n    background-color: ", ";\n    list-style-position: outside;\n  }\n\n  li {\n    ", ";\n    margin: 0;\n    padding: 0;\n  }\n\n  li > ul,\n  li > ol {\n    border: 0;\n    padding: 0;\n    margin: 0 0 0 ", ";\n  }\n\n  img {\n    height: auto;\n    max-width: 100%;\n  }\n"], ["\n  /* Heading styles to be rendered as bold paragraph for now. */\n  h1,\n  h2,\n  h3,\n  h4,\n  h5 {\n    ", "\n    margin: 0;\n    margin-bottom: ", ";\n    font-weight: ", ";\n  }\n  p {\n    ", "\n    margin: 0;\n    margin-bottom: ", ";\n  }\n\n  strong {\n    font-weight: ", ";\n  }\n\n  em {\n    font-style: italic;\n  }\n\n  a {\n    color: ", ";\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  ul {\n    list-style-type: disc;\n  }\n\n  ol {\n    list-style-type: decimal;\n  }\n\n  ul,\n  ol {\n    padding: ", ";\n    padding-left: ", ";\n    margin: 0 0 ", " 0;\n    border: 1px solid ", ";\n    border-radius: ", ";\n    background-color: ", ";\n    list-style-position: outside;\n  }\n\n  li {\n    ", ";\n    margin: 0;\n    padding: 0;\n  }\n\n  li > ul,\n  li > ol {\n    border: 0;\n    padding: 0;\n    margin: 0 0 0 ", ";\n  }\n\n  img {\n    height: auto;\n    max-width: 100%;\n  }\n"
    /**
     * `<Markdown>` is used to safely render markdown strings to HTML, it is a simple wrapper around
     * the [react-markdown](https://github.com/rexxars/react-markdown) component. This component only allows
     * certain types to be used in markdown that have been vetted by a designer:
     *
     * * `text`
     * * `break`
     * * `paragraph`
     * * `emphasis`
     * * `strong`
     * * `delete`
     * * `link`
     * * `image`
     * * `linkReference`
     * * `imageReference`
     * * `list`
     * * `listItem`
     */
])), typography.body, spacing.tight, fontWeight.bold, typography.body, spacing.tight, fontWeight.bold, color.theme.primaryColor.action.primary, spacing.default, spacing.extraLoose, spacing.default, divider.solid, borderRadius.default, color.theme.supportingColor.tint, typography.body, spacing.snug);
/**
 * `<Markdown>` is used to safely render markdown strings to HTML, it is a simple wrapper around
 * the [react-markdown](https://github.com/rexxars/react-markdown) component. This component only allows
 * certain types to be used in markdown that have been vetted by a designer:
 *
 * * `text`
 * * `break`
 * * `paragraph`
 * * `emphasis`
 * * `strong`
 * * `delete`
 * * `link`
 * * `image`
 * * `linkReference`
 * * `imageReference`
 * * `list`
 * * `listItem`
 */
export var Markdown = function (_a) {
    var children = _a.children, source = _a.source, // deprecated, but still used
    props = __rest(_a, ["children", "source"]);
    if (source !== undefined) {
        console.warn('`source` prop is deprecated.  Use `children` instead.');
    }
    return (React.createElement(MarkdownStyled, __assign({ plugins: [gfm], allowedTypes: [
            'heading',
            'text',
            'break',
            'paragraph',
            'emphasis',
            'strong',
            'delete',
            'link',
            'image',
            'linkReference',
            'imageReference',
            'list',
            'listItem'
        ] }, props), source !== null && source !== void 0 ? source : children));
};
var templateObject_1;
//# sourceMappingURL=index.js.map